import React from 'react'
import { Button } from '../../button/Button'
import './TermsToProfile.scss'

const TermsToProfile = () => {
    return (
        <>
            <div className="ttp__container">
                <Button buttonSize="btn--wide" buttonColor="blue">Go To Profile</Button>
                <p>Good Luck<br/>Have Fun</p>
            </div>
        </>
    )
}

export default TermsToProfile
